export const translationOverirdes = {
  "en": {
    "richStudent": [
      {
        "original": "Rich Man’s Daughter",
        "type": "name",
        "text": [
          "Rich Student"
        ]
      }
    ]
  }
}
